// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2 {
  font-size: 24px;
  font-weight: bold;
}

h5 {
  font-size: 16px;
  font-weight: bold !important;
  margin: 5px 0 !important;
}

h6 {
  font-size: 16px;
  font-weight: 550;
  margin: 5px 0 !important;
}

h6.bold-h6 {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/information-and-security/account-information/account-information.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,iBAAA;AACJ;;AAEA;EACI,eAAA;EACA,4BAAA;EACA,wBAAA;AACJ;;AAEA;EACI,eAAA;EACA,gBAAA;EACA,wBAAA;AACJ;;AAEA;EACI,iBAAA;AACJ","sourcesContent":["h2{\n    font-size: 24px;\n    font-weight: bold;\n}\n\nh5{\n    font-size: 16px;\n    font-weight: bold!important;\n    margin: 5px 0!important;\n}\n\nh6{\n    font-size: 16px;\n    font-weight: 550;\n    margin: 5px 0!important;\n}\n\nh6.bold-h6{\n    font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
